import React from 'react';
import { useScreenDetector } from '../../../hooks/useScreenDetector';

export default function Iframe(props) {
  const { isMobile } = useScreenDetector();

  return (
    <iframe src={props.slide.url} width={isMobile ? '100%' : props.slide.width} height={props.slide.height} className='mx-auto'></iframe>
  )
}
